'use client';
import { defaultTheme } from '@mnd-frontend/ui/shared/tokens';
import type { ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';

export const DefaultTheme = ({ children }: { children: ReactNode }) => {
  return <ThemeProvider theme={defaultTheme}>{children}</ThemeProvider>;
};
